import { useEffect, useMemo, useState } from 'react';

import { useActivityFormCommonController } from '~/components/ActivityFormBuilderPresets/Controllers/useActivityFormCommonController';

import { AboutFormProps, AppsForSelector } from './types';
import { createFormSchema } from './utils';

export const useAboutFormController = ({
  handleContinue,
  handleBack,
  defaultValues,
  requirementOptions,
  causeOptions,
  isLoading,
  isLoadingDefaultValues,
  connectedApps,
}: AboutFormProps) => {
  const defaultSelectedApp = (defaultValues as any)?.selectedApp?.[0] || '';

  const [appsForSelector, setAppsForSelector] = useState<AppsForSelector[]>([]);

  const commonController = useActivityFormCommonController({
    defaultSelectedApp,
  });

  const formSchema = useMemo(() => {
    return createFormSchema({
      causeOptions,
      requirementOptions,
      handleBack,
      connectedApps: appsForSelector,
      commonController,
    });
  }, [
    causeOptions,
    requirementOptions,
    handleBack,
    appsForSelector,
    commonController,
  ]);

  useEffect(() => {
    if (connectedApps && connectedApps?.length > 0) {
      const mappedApps = connectedApps.map((conenctedApp) => ({
        name: conenctedApp.name,
        value: conenctedApp._id,
        logo: conenctedApp.logo,
      }));

      setAppsForSelector(mappedApps);
    }
  }, [connectedApps]);

  return {
    causeOptions,
    formSchema,
    defaultValues,
    handleContinue,
    isLoading,
    isLoadingDefaultValues,
    formBuilderImperativeRef: commonController.formBuilderImperativeRef,
  };
};
